import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Icons } from 'ui/components'

import { USER_PERMISSION } from 'utils/constants/user'

export default function ({ currentPath }) {
  const userPermission = useSelector(state => state.user.permission)

  const renderAdmin = () => {
    if (userPermission !== USER_PERMISSION.ADMIN) return null

    return (
      <li>
        <div className="category">
          <Icons icon="settings" />
          Administração
        </div>

        <ul>
          <li>
            <Link
              className={(currentPath === '/admin/organization') ? 'selected' : ''}
              to="/admin/organization"
            >
              Organização
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === '/admin/organization-plan-cpf') ? 'selected' : ''}
              to="/admin/organization-plan-cpf"
            >
              Organização - Plano do CPF
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === '/admin/organization-plan-cnpj') ? 'selected' : ''}
              to="/admin/organization-plan-cnpj"
            >
              Organização - Plano do CNPJ
            </Link>
          </li>
        </ul>
      </li>
    )
  }

  return (
    <nav>
      <ul>
        <li>
          <div className="category">
            <Icons icon="settings" />
            Configurações
          </div>

          <ul>
            <li>
              <Link
                className={(currentPath === '/config/user') ? 'selected' : ''}
                to="/config/user"
              >
                Usuário
              </Link>
            </li>
          </ul>
        </li>

        {renderAdmin()}
      </ul>
    </nav>
  )
}
